export default {
	Ratio:0,
	ChampionOnly:1
}


// WEBPACK FOOTER //
// ./src/utils/constants/advancerPolicy.js